import React from 'react';

class ScrollButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enabled: false,
    };
    this.ee = props.ee;

    // ee.on('hu-display-scrollbottom', (display) => {
    //   this.setState({
    //     enabled: display,
    //   });
    // });
  }

  onClick() {
    this.ee.emit('hu-scroll-button-click');
    this.ee.emit('hu-lb-key-arrowdown');
  }

  render() {
    // const { clickHandler } = this.props;
    const { enabled } = this.state;

    // if (!enabled)
    //   return null;

    return (
      <div className="hu-scroll-bottom">
        <button className="scroll-bottom-button" onClick={this.onClick.bind(this)}>
          {/* {<svg className="hu-stroke_accent" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
            <polyline points="1.5 7 10 14 18.5 7" stroke-width="2"></polyline>
          </svg>} */}
          <svg width="14px" height="15px" viewBox="0 0 14 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path className="hu-fill_accent" d="M7.8984375,0.83984375 L7.8984375,12.0507812 L11.9609375,7.83203125 C12.1302092,7.64973867 12.3320301,7.55859375 12.5664062,7.55859375 C12.8007824,7.55859375 13.0058585,7.63997314 13.1816406,7.80273437 C13.3574228,7.96549561 13.4453125,8.16406133 13.4453125,8.3984375 C13.4453125,8.63281367 13.3671883,8.84114492 13.2109375,9.0234375 L7.6640625,14.765625 C7.49479082,14.9479176 7.28971475,15.0390625 7.04882812,15.0390625 C6.8079415,15.0390625 6.60286543,14.9479176 6.43359375,14.765625 L0.8671875,8.984375 C0.710936719,8.81510332 0.6328125,8.61979277 0.6328125,8.3984375 C0.6328125,8.15104043 0.723957422,7.94270918 0.90625,7.7734375 C1.07552168,7.60416582 1.27734258,7.52278643 1.51171875,7.52929687 C1.74609492,7.53580732 1.94791582,7.62369707 2.1171875,7.79296875 L6.1796875,12.0117188 L6.1796875,0.8203125 C6.1796875,0.598957227 6.25781172,0.40364668 6.4140625,0.234375 C6.57031328,0.0651033203 6.75911348,-0.0260416016 6.98046875,-0.0390625 C7.22786582,-0.0520833984 7.44270742,0.0292959961 7.625,0.205078125 C7.80729258,0.380860254 7.8984375,0.59244668 7.8984375,0.83984375 Z" id="" fill="#FFFFFF"></path>
            </g>
          </svg>
        </button>
      </div>
    );
  }
}

export default ScrollButton;


// WEBPACK FOOTER //
// ./app/js/components/messenger/ScrollButton.js